import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import React from "react";
import { PageContainer } from "./PageContainer";
export function HowItWorks(_param) {
    var heading = _param.heading, subheading = _param.subheading, steps = _param.steps, _animate = _param.animate, animate = _animate === void 0 ? undefined : _animate, _className = _param.className, className = _className === void 0 ? "" : _className, rest = _object_without_properties(_param, [
        "heading",
        "subheading",
        "steps",
        "animate",
        "className"
    ]);
    return /*#__PURE__*/ _jsxs(PageContainer, _object_spread_props(_object_spread({
        className: className
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: clsx("space-y-8 w-full flex-auto text-center items-center", "flex flex-col"),
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-3xl font-medium",
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "max-w-2xl font-medium text-xl",
                        children: subheading
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: clsx("flex flex-col space-y-8 items-stretch flex-auto"),
                children: steps.map(function(step, i) {
                    return /*#__PURE__*/ _jsx(Step, _object_spread({
                        animate: animate,
                        number: i + 1,
                        flip: i % 2 !== 0
                    }, step), i);
                })
            })
        ]
    }));
}
var Step = function(_param) {
    var heading = _param.heading, subheading = _param.subheading, number = _param.number, image = _param.image, cta = _param.cta, decorativeHeading = _param.decorativeHeading, _flip = _param.flip, flip = _flip === void 0 ? false : _flip, _animate = _param.animate, animate = _animate === void 0 ? undefined : _animate, rest = _object_without_properties(_param, [
        "heading",
        "subheading",
        "number",
        "image",
        "cta",
        "decorativeHeading",
        "flip",
        "animate"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: clsx("flex items-center justify-between gap-8", "flex-col", flip ? "md:flex-row-reverse" : "md:flex-row")
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-[300px] max-w-[50%] flex-auto space-y-6 ",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end opacity-40",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "opacity-70 text-7xl",
                                children: number
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "truncate max-w-[300px] font-semibold ",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mx-2",
                                        children: " . "
                                    }),
                                    decorativeHeading !== null && decorativeHeading !== void 0 ? decorativeHeading : heading
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "opacity-90 font-medium leading-relaxed text-2xl",
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "max-w-[90%] font-medium leading-relaxed opacity-[0.66] ",
                        children: subheading
                    }),
                    cta && /*#__PURE__*/ _jsx("div", {
                        className: "",
                        children: cta
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "min-w-[300px] shrink-0 max-w-[540px] flex-auto",
                children: image
            })
        ]
    }));
};
